import { render, staticRenderFns } from "./CurrentVideo.vue?vue&type=template&id=da3a8d4e&"
import script from "./CurrentVideo.vue?vue&type=script&lang=js&"
export * from "./CurrentVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports